import { rem, Flex, Header, IconButton } from '@vimeo/bokeh';
import { ChevronLeft } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { CallablePlaceholder } from '../../types/general';
import { createDomName } from '../../utils/dom/identifying';

interface IBackButtonPanelProps extends IBaseDomElementProps {
  title: string;
  headerSize?: string;
  padding?: string | number;
  margin?: string | number;
  onClick: () => void;
}

export function BackButtonPanel({
  id = createDomName('panel-back-button'),
  className = createDomName('panel-back-button'),
  title,
  headerSize,
  padding,
  margin,
  onClick = CallablePlaceholder,
}: IBackButtonPanelProps) {
  return (
    <Flex
      id={id}
      className={className}
      alignItems={'center'}
      width={'100%'}
      cursor={'pointer'}
      padding={padding}
      margin={margin}
      onClick={onClick}
    >
      <IconButton
        id={createDomName(id, 'arrow')}
        className={createDomName(className, 'arrow')}
        aria-label={'Back'}
        variant={'minimal'}
        size={'sm'}
        icon={<ChevronLeft />}
      />

      <Header
        id={createDomName(id, 'header')}
        className={createDomName(className, 'header')}
        marginLeft={rem(4)}
        size={headerSize ?? 'sm'}
      >
        {title}
      </Header>
    </Flex>
  );
}
